import { useState, useEffect } from 'react';
import { Box, Container, Grid, Pagination, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { VideoCard } from './VideoCard';
import Masonry from '@mui/lab/Masonry';
import { fetchVideos } from '../../api/videoService';
import { VideoItem } from '../../api/videoService';
import { VideoCardSkeleton } from './VideoCardSkeleton';

const SORT_OPTIONS = [
  { value: 'newest', label: 'Сначала новые' },
  { value: 'popular', label: 'По популярности' },
  { value: 'likes', label: 'По лайкам' },
];

export const VideoPage = () => {
  const [videos, setVideos] = useState<VideoItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState('newest');
  const [loading, setLoading] = useState(true);
  const limit = 12;

  useEffect(() => {
    const loadVideos = async () => {
      setLoading(true);
      try {
        const { data, total } = await fetchVideos((page - 1) * limit, limit, sort);
        setVideos(data);
        setTotal(total);
      } finally {
        setLoading(false);
      }
    };

    loadVideos();
  }, [page, sort]);

  return (
    <Container maxWidth={false}>
      {/* Фильтры и сортировка */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ minWidth: 200 }}>
          <FormControl fullWidth>
            <InputLabel>Сортировка</InputLabel>
            <Select
              value={sort}
              label="Сортировка"
              onChange={(e) => setSort(e.target.value)}
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Мозаичная сетка видео */}
      {loading ? (
        <Masonry columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={3} className='my-masonry-grid' 
        >
          {Array.from({ length: limit }).map((_, index) => (
            <VideoCardSkeleton 
              key={index} 
            //   variant="rectangular" 
            //   height={Math.random() * 100 + 300} 
            //   sx={{ borderRadius: 2 }} 
            />
          ))}
        </Masonry>
      ) : (
        <Masonry columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={3} className='my-masonry-grid' >
          {videos.map((video) => (
            <div key={video.id} className="flip-card">
            <VideoCard video={video} />
          </div>
          ))}
        </Masonry>
      )}

      {/* Пагинация */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination
          count={Math.ceil(total / limit)}
          page={page}
          onChange={(_, value) => setPage(value)}
          color="primary"
          size="large"
        />
      </Box>
    </Container>
  );
};